const viewTogglev2 = () => {
    
    const viewToggleEl2 = document.getElementsByClassName('view-toggle-v2__item');
    const viewToggleContent2 = document.getElementsByClassName('view-toggle-v2__content');
    const viewToggleEvent2 = new Event('view-toggle-eventv2', { "bubbles" : true });

    document.addEventListener('click', function(event) {

        let targetv2 = event.target.dataset.targetv2;

        if ( !targetv2 ) {
            if ( event.target.closest('.view-toggle-v2__item') ) targetv2 = event.target.closest('.view-toggle-v2__item').dataset.targetv2;
        }
        if (!targetv2) return;

        for (var i = 0; i < viewToggleContent2.length; i++) {
            viewToggleContent2[i].style.display = "none";
        }

        for (var i = 0; i < viewToggleEl2.length; i++) {
            viewToggleEl2[i].classList.remove("active");
        }



        event.target.classList.add('active');
        let final = document.querySelector(targetv2);
        final.style.display = "block";
        final.dispatchEvent(viewToggleEvent2);

    });

   
    
}
export default viewTogglev2;
